import { API, API_GET } from "../../config";


export const GetReportList = () => {
  return API_GET(API.Reportlist);
};
